/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import {
  Button,
  Card,
  CardContent,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

const HistoryRobotList = ({
  loading,
  robots,
  errorRobots,
  selectedRobot,
  handleOpen,
}) => (
  <Card variant="outlined">
    <CardContent>
      {loading && <LinearProgress color="secondary" sx={{ my: 3 }} />}
      {!loading &&
        ((robots && robots.length < 1) || errorRobots) &&
        (errorRobots || '등록된 로봇이 없습니다.')}
      {!loading && robots && (
        <List>
          {robots.map((item) => (
            <ListItem
              secondaryAction={
                <Button
                  size="small"
                  color="secondary"
                  variant="contained"
                  onClick={() => handleOpen(item)}
                >
                  보기
                </Button>
              }
              selected={
                selectedRobot &&
                'id' in selectedRobot &&
                selectedRobot.id === item.id
              }
              key={item.id}
            >
              <ListItemText
                primary={
                  item.alias ? (
                    <span>{`${item.alias} (${item.serial})`}</span>
                  ) : (
                    <span>{`${item.serial}`}</span>
                  )
                }
              />
            </ListItem>
          ))}
        </List>
      )}
    </CardContent>
  </Card>
);

export default HistoryRobotList;
